import { forwardRef } from 'react'

import { ProductListSectionThreeDS } from '@src/components/blocks/product-list-section-three-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { ProductListSectionThreeLegacy } from './product-list-section-three-legacy'

import type { ProductListSectionThreeProps } from './product-list-section-three.types'

const ProductListSectionThree = forwardRef<HTMLDivElement, ProductListSectionThreeProps>(
  function ProductListSectionThreeRouter(props, ref) {
    if (shouldUseDesignSystem()) {
      return <ProductListSectionThreeDS {...props} ref={ref} />
    }
    return <ProductListSectionThreeLegacy {...props} ref={ref} />
  },
)

export default ProductListSectionThree
export { ProductListSectionThree }
export type { ProductListSectionThreeProps } from './product-list-section-three.types'
